import script from "./DeleteReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteReport.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__